<template>
	<v-sheet rounded class="mb-4">
		<v-card color="#125B92" elevation="0" class="rounded-b-0">
			<v-card-title class="align-center">
				<h3 class="white--text">{{ project.name }}</h3>
				<v-spacer />
			</v-card-title>
			<v-divider />
			<v-card-text class="white">
				<v-row>
					<v-col cols="6">
						<v-row>
							<v-col><strong>Client:</strong></v-col>
							<v-col>
								<Link v-if="auth.user_type === 1" :href="route('clients.show', project.client)">{{ project.client.name }}</Link>
								<span v-else>{{ project.client.name }}</span>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="6">
						<v-row>
							<v-col><strong>Manager:</strong></v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row class="mt-0">
					<v-col cols="6">
						<v-row>
							<v-col><strong>Orderer:</strong></v-col>
							<v-col>{{ project.orderer.first_name }} {{ project.orderer.last_name }}</v-col>
						</v-row>
					</v-col>
					<v-col cols="6">
						<v-row>
							<v-col><strong>Due Date:</strong></v-col>
							<v-col>{{ project.due_date | localDate }}</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row class="mt-0">
					<v-col cols="6">
						<v-row>
							<v-col><strong>Reason For Job:</strong></v-col>
							<v-col>{{ project.reason }}</v-col>
						</v-row>
					</v-col>
					<v-col cols="6">
						<v-row>
							<v-col cols="12">
								<strong>Sector:</strong> <em>{{ project.sector }}</em> &nbsp;|&nbsp;
								<strong>Activity:</strong> <em>{{ project.activity }}</em>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-text style="background-color:#F9F9FB">
				<p class="font-weight-bold mb-0">Notes:</p>
				<p v-if="project.notes" class="mb-0 text-pre-line">{{ project.notes }}</p>
				<p v-else class="mb-0 text-pre-line">No notes were found for this project. Edit the project to add some.</p>
			</v-card-text>
		</v-card>
	</v-sheet>
</template>
<script>

export default {
	props: {
		project: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			auth: this.$page.props.auth
		}
	}
}
</script>
